import { makeStyles } from "@mui/styles";
import styled from "styled-components";

export const useStyles = makeStyles((theme) => ({
    root: {
        "& .MuiPaper-root": {
            marginBottom: "16px",
        },
    },
    wrapper: {
        background: "white",
        position: "sticky",
        top: "0px",
        zIndex: 10,
        height: "150px",
        padding: "20px",
        marginBottom: "16px",
    },
    preview: {
        display: "flex",
        justifyContent: "space-between",
        padding: "10px",
    },
    closeIcon: {
        cursor: "pointer",
    },
    container: {
        marginTop: "10px",
        marginBottom: "16px",
    },
    pdfWrapper: {
        marginTop: "50px",
        position: "relative",
        zIndex: -9999,
        marginBottom: "16px",
    },
    imageWrapper: {
        display: "flex",
        gap: "40px",
        marginBottom: "16px",
    },
    form: {
        display: "flex",
        gap: "16px",
        marginBottom: "16px",
    },
    paper: {
        padding: "16px",
        marginBottom: "16px",
    },
    textField: {
        width: "250px",
    },
    createButton: {
        width: "150px",
    },
    selectButton: {
        width: "200px",
    },
    menuItem: {
        background:"#F7F5FF",
        padding: "8px 16px"
    },
    menuSubItem: {
        padding: "8px 16px",
        textTransform: 'uppercase',
    },
}));

